/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button, Grid, Dialog, DialogTitle, DialogActions, DialogContent, TextField,
} from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import locale from 'date-fns/locale/pt-BR';
import DateFnsUtils from '@date-io/date-fns';
import Select from 'react-select';
import Loading from '../../../components/loading/Loading';
import FlashContext from '../../../components/contexts/FlashContext';
import api from '../../../service/axios/api';

const selectStyles = {
  control: provided => ({ ...provided, height: 56, minHeight: 56 }),
  menu: provided => ({ ...provided, zIndex: 9999 }),
  menuPortal: base => ({ ...base, zIndex: 9999 }),
};

export default function UpdateStatus({
  openUpdate, setOpenUpdate, loadingUpdate, handleUpdate, dueDate: initialDueDate,
}) {
  const { t } = useTranslation();
  const { notifyError } = useContext(FlashContext);

  const [realizedValue, setRealizedValue] = useState('');
  const [dateIssue, setDateIssue] = useState(null);
  const [dueDate, setDueDate] = useState(null);
  const [bankId, setBankId] = useState(null);
  const [bankList, setBankList] = useState([]);

  const getBanks = async () => {
    try {
      const data = await api.banks.get(false, 'Active');
      setBankList(data.retorno.map(i => ({ value: i.id, label: i.bank })));
    } catch (error) { notifyError(error.message); }
  };

  useEffect(() => {
    if (openUpdate) {
      getBanks();
      // limpa os campos ao reabrir
      setRealizedValue('');
      setDateIssue(null);
      setBankId(null);
      setDueDate(initialDueDate || null);
    }
  }, [openUpdate]);

  const handleConfirm = () => {
     handleUpdate({
      realizedValue, dateIssue, bankId, dueDate,
    });
  };

  return (
    <Dialog onClose={() => setOpenUpdate(false)} open={openUpdate} fullWidth maxWidth="sm">
      <Loading open={loadingUpdate} msg={t('billsToPay.updateDialog.loading')} />
      <DialogTitle>{t('billsToPay.updateDialog.title')}</DialogTitle>
      <DialogContent>
        <Grid container spacing={3} style={{ justifyContent: 'center' }}>

          <Grid item xs={12} sm={8}>
            <p style={{ fontSize: '18px', textAlign: 'justify' }}>
              {t('billsToPay.updateDialog.message')}
            </p>
          </Grid>

          {/* Valor Realizado */}
          <Grid item sm={6} xs={12}>
            <TextField
              fullWidth
              label="Valor Realizado"
              variant="outlined"
              value={realizedValue}
              onChange={e => setRealizedValue(e.target.value)}
              placeholder="0,00"
            />
          </Grid>

          {/* Conta Bancária */}
          <Grid item sm={6} xs={12}>
            <Select
              value={bankList.find(opt => opt.value === bankId) || null}
              placeholder="Conta Bancária"
              onChange={e => setBankId(e ? e.value : null)}
              options={bankList}
              styles={selectStyles}
              isClearable
              menuPortalTarget={document.body}
            />
          </Grid>

          {/* Data de Pagamento */}
          <Grid item sm={6} xs={12}>
            <MuiPickersUtilsProvider locale={locale} utils={DateFnsUtils}>
              <KeyboardDatePicker
                autoOk
                label="Data de Pagamento"
                variant="inline"
                inputVariant="outlined"
                style={{ backgroundColor: '#fff' }}
                size="medium"
                format="dd/MM/yyyy"
                InputProps={{ readOnly: true }}
                InputAdornmentProps={{ position: 'start' }}
                value={dateIssue}
                onChange={date => setDateIssue(date)}
              />
            </MuiPickersUtilsProvider>
          </Grid>

 {/* Data de Vencimento (editável) */}
          <Grid item sm={6} xs={12}>
            <MuiPickersUtilsProvider locale={locale} utils={DateFnsUtils}>
              <KeyboardDatePicker
                autoOk
                label="Data de Vencimento"
                variant="inline"
                inputVariant="outlined"
                style={{ backgroundColor: '#fff' }}
                size="medium"
                format="dd/MM/yyyy"
                InputProps={{ readOnly: true }}
                InputAdornmentProps={{ position: 'start' }}
                value={dueDate}
                onChange={date => setDueDate(date)}
              />
            </MuiPickersUtilsProvider>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button style={{ height: 40 }} onClick={() => setOpenUpdate(false)} variant="text" color="primary">
          {t('billsToPay.createDialog.buttons.cancel')}
        </Button>
        <Button onClick={handleConfirm} variant="contained" disabled={loadingUpdate} color="primary">
          {t('billsToPay.updateDialog.buttons.update')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}